export type IconProps = {
  icon: string;
  color?: "text-primary" | "text-secondary" | "text-dark" | "text-danger" | "text-success" | "g2-text-orange" | "";
  style?: React.CSSProperties;
  title?: string;
  me?: number;
  ms?: number;
};

export default function Icon({ icon, color = "", style = {}, title = "", me = 2, ms = 0 }: IconProps) {
  return <i className={`bi bi-${icon} me-${me} ms-${ms} ${color}`} title={title} style={style}></i>;
}
